import React from 'react';
import FixedBottomNavBar from '../../../../components/FixedBottomNavBar';
import Button from '../../../../components/Button';
import './PointGenerateNavbar.scss';

const PointGenerateNavbar = (props) => {
  const { onSubmit, toggleModal } = props;

  return (
    <FixedBottomNavBar className="point-generate-navbar">
      {/*발급*/}
      <Button
        color="light"
        text="엑셀일괄발급"
        onClick={() =>
          toggleModal({
            name: 'excelBulkGeneratePointModal',
            value: true,
          })
        }
      />

      {/*발급*/}
      <Button color="primary" text="발급" onClick={() => onSubmit()} />
    </FixedBottomNavBar>
  );
};

export default PointGenerateNavbar;
